import { create } from 'zustand';
import { AuthModalProps, ModelsState, QrModalProps } from './types';

const useModalsStore = create<ModelsState>(set => ({
  qrModal: null,
  authModal: null,
  toggleAuthModal: (action: AuthModalProps) => set({ authModal: action }),
  toggleQrModal: (action: QrModalProps) => set({ qrModal: action }),
}));

export default useModalsStore;
